module.exports = __webpack_public_path__ + "img/case-corp_service.7302041d.png";